import { Component, Prop, Vue } from 'vue-property-decorator';
import tinycolor from 'tinycolor2';
import labelTypes from '@/_helpers/labelTypes';
import template from './LabelChip.vue';

@Component({
	mixins: [template]
})
export default class LabelChip extends Vue {
	@Prop() selected: boolean;

	@Prop() small: boolean;

	@Prop() close: boolean;

	@Prop() labelType: number;

	@Prop() name: string;

	public get label(): any {
		return labelTypes[this.labelType] || false;
	}

	getIconColor(iconColor: string): string {
		const color = tinycolor(iconColor)
			.darken(30)
			.toString();
		return color;
	}
}
